<template>
    <user-profile-picture :userEmail="comment && comment.userid" cssClass="user-icon" />
    <div class="comment-form d-flex flex-column" :id='comment && comment.id' >
      <comment-card
          :comment="comment"
          :forceShowDeleteCommentButtons="forceShowDeleteCommentButtons"
          @commentDeleted="emitCommentDeleted" />

      <div v-if="!commentMarkedAsDeleted" class="likes">
        <div class="d-flex justify-content-between align-items-center comment-likes">
          <div>
            <!--<a href="#" class="active" title="Gefällt mir aktivieren">Gefällt mir</a> •-->
            <button @click="toggleAnswerBox" class="open-comment-reply-input" >Antworten</button>
          </div>

          <likes
            category="comments"
            :bundleId="threadId"
            :likedContentUuid="comment && comment.id"
            @likesUpdated="emitLikesUpdated" />
        </div>
      </div> <!-- /likes -->
      <!-- REPLIES BEGIN -->
      <new-comment-box
          v-if="showAnswerBox && !commentMarkedAsDeleted"
          :threadId="threadId"
          :parentThreadId="comment && comment.id"
          @newComment="emitNewCommentReply"
          :focusWhenShown="true"
      />
      <div v-if="comment && [comment.replies !== undefined]" class="mt-3 comment-replies">
        <template v-for="reply in comment.replies" :key="reply.id">
          <div v-if="!(reply.deleted === true)" class="comment p-12 pe-0 d-flex align-items-start">
            <single-comment-reply
                v-if="!(reply && reply.deleted)"
                :reply="reply"
                :forceShowDeleteCommentButtons="forceShowDeleteCommentButtons"
                @commentDeleted="emitCommentDeleted" />
          </div>
        </template>

      </div>
      <!-- REPLIES END -->
    </div> <!-- /comment-form -->
</template>
<script lang="ts">


import { defineComponent } from 'vue'
import NewCommentBox from './NewCommentBox.vue';
import UserProfilePicture from './UserProfilePicture.vue';
import moment from 'moment';
import SingleCommentReply from './SingleCommentReply.vue';
import Likes from '../likes/Likes.vue';
import CommentCard from './CommentCard.vue';
import { Comment } from '@/generated/openapi';

export default defineComponent({
  components: { NewCommentBox, UserProfilePicture, SingleCommentReply, CommentCard, Likes },

  name: 'SingleComment',
  props: {
    threadId: String,
    comment: {
      type: Object as () => Comment
    },
    forceShowDeleteCommentButtons: Boolean,
  },
  emits: ['newCommentReply', 'likesUpdated', 'commentDeleted'],
  data() {
    return {
      threadIdLocal: '',
      showAnswerBox: false
    };
  },
  mounted() {
    if (this.threadId !== undefined) {
      this.threadIdLocal = this.threadId
    }
    moment.locale('de')
  },
  computed: {
    commentMarkedAsDeleted():boolean {
      if(this.comment?.deleted === true) {
        return true
      }
      return false
    }
  },
  methods: {
    toggleAnswerBox(): void {
      this.showAnswerBox = !this.showAnswerBox
    },
    emitNewCommentReply(): void {
      this.showAnswerBox = false
      this.$emit('newCommentReply')
    },
    emitLikesUpdated(): void {
      this.$emit("likesUpdated")
    },
    emitCommentDeleted(): void {
      this.$emit('commentDeleted')
    }
  }
});

</script>
<style scoped>
  button.open-comment-reply-input {
    border: none;
    background-color: transparent;
    padding: 0;
    margin: 0;
  }
</style>
